import PlanningTableData from './PlanningTable.json';

export const masterColumnDefs = [
  { columnId: 'APPROVER', columnType: 'APPROVER', displayName: 'Approver name' },
  { columnId: 'COMPENSATION_CYCLE', columnType: 'COMPENSATION_CYCLE', displayName: 'Compensation cycle' },
  { columnId: 'BUDGET_STATUS', columnType: 'BUDGET_STATUS', displayName: 'Budget status' },
  { columnId: 'BUDGET_BAR', columnType: 'BUDGET_BAR', displayName: 'Budget bar' },
];

export const detailsColumnDefs = [
  { columnId: 'EMPLOYEE', columnType: 'EMPLOYEE', displayName: 'Employee name' },
  { columnId: 'RATING', columnType: 'RATING', displayName: 'Performance rating' },
  { columnId: 'CHURN_LIKELIHOOD', columnType: 'CHURN_LIKELIHOOD', displayName: 'Churn likelihood' },
  { columnId: 'WAITING_ON', columnType: 'WAITING_ON', displayName: 'Waiting on' },
  { columnId: 'EFFECTIVE_DATE', columnType: 'EFFECTIVE_DATE', displayName: 'Effective date' },
  { columnId: 'COMPA_RATIO', columnType: 'COMPA_RATIO', displayName: 'Compa ratio' },
  { columnId: 'BASE_RATE', columnType: 'BASE_RATE', displayName: 'Current rate' },
  { columnId: 'RECOMMENDATION', columnType: 'RECOMMENDATION', displayName: 'Proposed recommendation' },
  { columnId: 'APPROVED_PAY', columnType: 'APPROVED_PAY', displayName: 'Approved pay' },
  { columnId: 'FINAL_PAY', columnType: 'FINAL_PAY', displayName: 'Final pay' },
  { columnId: 'FLAGGED_PROPOSAL', columnType: 'FLAGGED_PROPOSAL', displayName: 'Flagged proposal' },
];

export const masterRowData = [
  {
    APPROVER: {
      id: 1001,
      companyId: 1,
      displayName: 'Paul Porter',
      profilePhoto: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-1.png',
      designation: 'Floor manager',
      ownerType: null,
      employeeFunction: 'Kitchen',
      email: 'paul.porter@abc.co',
      personalEmail: 'paul.porter@abc.co',
      workEmail: 'paul.porter@abc.co',
      preferredName: 'Paul',
      mainRole: 'Floor manager',
      otherRoles: ['Chef', 'Cashier'],
    },
    COMPENSATION_CYCLE: 'Q1 2024 Performance review',
    BUDGET_STATUS: 'EXCEEDED',
    BUDGET_BAR: {
      allocatedBudget: {
        value: 36708,
        currency: 'USD',
        symbol: '$',
      },
      additionalBudget: {
        value: 4189,
        currency: 'USD',
        symbol: '$',
      },
      targetBudget: {
        value: 42500,
        currency: 'USD',
        symbol: '$',
      },
      totalBudget: {
        value: 45382,
        currency: 'USD',
        symbol: '$',
      },
    },
  },
  {
    APPROVER: {
      id: 1002,
      companyId: 1,
      displayName: 'Alex Travis II',
      profilePhoto: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-2.png',
      designation: 'Server',
      ownerType: null,
      employeeFunction: 'Front office',
      email: 'alex.travis.ii@abc.co',
      personalEmail: 'alex.travis.ii@abc.co',
      workEmail: 'alex.travis.ii@abc.co',
      preferredName: 'Alex',
      mainRole: 'Server',
      otherRoles: ['Floor manager', 'Chef'],
    },
    COMPENSATION_CYCLE: 'Q1 2024 Performance review',
    BUDGET_STATUS: 'EXCEEDED',
    BUDGET_BAR: {
      allocatedBudget: {
        value: 32891,
        currency: 'USD',
        symbol: '$',
      },
      additionalBudget: {
        value: 6497,
        currency: 'USD',
        symbol: '$',
      },
      targetBudget: {
        value: 41200,
        currency: 'USD',
        symbol: '$',
      },
      totalBudget: {
        value: 43776,
        currency: 'USD',
        symbol: '$',
      },
    },
  },
  {
    APPROVER: {
      id: 1003,
      companyId: 1,
      displayName: 'Sara Huffman',
      profilePhoto: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-3.png',
      designation: 'Cashier',
      ownerType: null,
      employeeFunction: 'Operations',
      email: 'sara.huffman@abc.co',
      personalEmail: 'sara.huffman@abc.co',
      workEmail: 'sara.huffman@abc.co',
      preferredName: 'Sara',
      mainRole: 'Cashier',
      otherRoles: ['Floor manager', 'Chef'],
    },
    COMPENSATION_CYCLE: 'Q1 2024 Performance review',
    BUDGET_STATUS: 'EXCEEDED',
    BUDGET_BAR: {
      allocatedBudget: {
        value: 31776,
        currency: 'USD',
        symbol: '$',
      },
      additionalBudget: {
        value: 5501,
        currency: 'USD',
        symbol: '$',
      },
      targetBudget: {
        value: 37600,
        currency: 'USD',
        symbol: '$',
      },
      totalBudget: {
        value: 37753,
        currency: 'USD',
        symbol: '$',
      },
    },
  },
  {
    APPROVER: {
      id: 1004,
      companyId: 1,
      displayName: 'Mark Gray',
      profilePhoto: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-4.png',
      designation: 'Cashier',
      ownerType: null,
      employeeFunction: 'Operations',
      email: 'mark.gray@abc.co',
      personalEmail: 'mark.gray@abc.co',
      workEmail: 'mark.gray@abc.co',
      preferredName: 'Mark',
      mainRole: 'Cashier',
      otherRoles: ['Floor manager', 'Chef'],
    },
    COMPENSATION_CYCLE: 'Q1 2024 Performance review',
    BUDGET_STATUS: 'WITHIN_BUDGET',
    BUDGET_BAR: {
      allocatedBudget: {
        value: 39143,
        currency: 'USD',
        symbol: '$',
      },
      additionalBudget: {
        value: 8051,
        currency: 'USD',
        symbol: '$',
      },
      targetBudget: {
        value: 49800,
        currency: 'USD',
        symbol: '$',
      },
      totalBudget: {
        value: 52394,
        currency: 'USD',
        symbol: '$',
      },
    },
  },
  {
    APPROVER: {
      id: 1005,
      companyId: 1,
      displayName: 'Margaret Robinson',
      profilePhoto: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultImages/defaultPhoto-5.png',
      designation: 'Server',
      ownerType: null,
      employeeFunction: 'Front office',
      email: 'margaret.robinson@abc.co',
      personalEmail: 'margaret.robinson@abc.co',
      workEmail: 'margaret.robinson@abc.co',
      preferredName: 'Margaret',
      mainRole: 'Server',
      otherRoles: ['Floor manager', 'Chef'],
    },
    COMPENSATION_CYCLE: 'Q1 2024 Performance review',
    BUDGET_STATUS: 'WITHIN_BUDGET',
    BUDGET_BAR: {
      allocatedBudget: {
        value: 27712,
        currency: 'USD',
        symbol: '$',
      },
      additionalBudget: {
        value: 6715,
        currency: 'USD',
        symbol: '$',
      },
      targetBudget: {
        value: 36000,
        currency: 'USD',
        symbol: '$',
      },
      totalBudget: {
        value: 37895,
        currency: 'USD',
        symbol: '$',
      },
    },
  },
];

export const detailsRowData = PlanningTableData.rows;
